import React from "react";

import { Grid, makeStyles } from "@material-ui/core";

// react-admin's layouts hand the record to their direct children only, so a
// wrapper that stands between the layout and a section has to pass that on
// itself — the same list FormSection forwards.
const INJECTED_PROPS = [
  "record",
  "basePath",
  "resource",
  "variant",
  "margin",
  "version",
];

const useStyles = makeStyles((theme) => ({
  column: {
    // A column is a fraction of the form's width, which is narrower than the
    // two-up rows the show sections lay out were written for. Stack those rows
    // until the viewport is wide enough that the column is not cramped.
    [theme.breakpoints.down("md")]: {
      "& .MuiGrid-container > .MuiGrid-item": {
        flexBasis: "100%",
        maxWidth: "100%",
      },
    },
  },
}));

/**
 * Side-by-side columns inside a SimpleForm/SimpleShowLayout — one column per
 * child, even widths, stacked below the `md` breakpoint.
 */
export const FormColumns = ({ children, spacing = 1, ...props }) => {
  const classes = useStyles();
  const columns = React.Children.toArray(children).filter((child) =>
    React.isValidElement(child),
  );
  const width = Math.max(1, Math.floor(12 / Math.max(1, columns.length)));
  const injected = INJECTED_PROPS.reduce((acc, key) => {
    if (props[key] !== undefined) acc[key] = props[key];
    return acc;
  }, {});

  return (
    <Grid container direction="row" spacing={spacing} alignItems="flex-start">
      {columns.map((child, index) => (
        <Grid
          item
          xs={12}
          md={width}
          key={child.key || index}
          className={classes.column}
        >
          {React.cloneElement(child, injected)}
        </Grid>
      ))}
    </Grid>
  );
};

// FormInput stamps a fixed width on any form child that does not declare
// fullWidth, which would pinch the whole row down to an input's width.
FormColumns.defaultProps = {
  fullWidth: true,
};
